const Pricing = {
  label: 'Pricing',
  url: '/pricing',
  heapClass: 'ca_topnav_pricing'
}

export default Pricing
